// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5302":"92b34ad542ee7d8b","8500":"67ddd2a5b0a316f1"}[chunkId] + ".js";
};